<gbc-tile-spinner [observable]="options$" height="400px">
  @if (visible) {
    @if (options$ | async; as options) {
      <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="options"
        style="width: 100%; height: 400px; display: block"
      ></highcharts-chart>
    }
  }
</gbc-tile-spinner>
